import {
  CommercialAddress,
  ClientData,
  ProposalOperationalDetails,
} from "../types/proposal";

export const createEmptyAddress = (): CommercialAddress => ({
  zipCode: "",
  street: "",
  number: "",
  complement: "",
  neighborhood: "",
  city: "",
  state: "",
});

export const createEmptyOperationalDetails = (
  client?: ClientData,
): ProposalOperationalDetails => ({
  payment: {
    method: "",
    paymentLink: "",
    payerName: "",
    payerDocument: "",
    dueDate: "",
    paidAt: "",
  },
  shipping: {
    recipientName: client?.name ?? "",
    recipientPhone: client?.phone ?? "",
    address: {
      ...createEmptyAddress(),
      ...client?.address,
      zipCode: client?.address?.zipCode ?? client?.zipCode ?? "",
    },
  },
  billing: {
    sameAsShipping: true,
    address: createEmptyAddress(),
  },
  delivery: {
    carrier: "",
    trackingCode: "",
    requestedAt: "",
    shippedAt: "",
  },
  notes: "",
});

export const normalizeOperationalDetails = (
  details?: ProposalOperationalDetails,
): ProposalOperationalDetails => {
  const empty = createEmptyOperationalDetails();
  if (!details) return empty;

  return {
    payment: { ...empty.payment, ...details.payment },
    shipping: {
      ...empty.shipping,
      ...details.shipping,
      address: { ...empty.shipping.address, ...details.shipping?.address },
    },
    billing: {
      ...empty.billing,
      ...details.billing,
      address: { ...empty.billing.address, ...details.billing?.address },
    },
    delivery: { ...empty.delivery, ...details.delivery },
    notes: details.notes ?? "",
  };
};
